import _ from 'lodash';

const stringValues = val => ({
  value: val,
  label: val
});

export const toUI = {
  adminGroup: group => ({
    value: group.Id,
    label: group.Name
  }),
  adminPotentialTraders: potTrader => ({
    value: potTrader.UserPrincipalName,
    label: potTrader.Name
  }),
  commodityShortcut: stringValues,
  baseProduct: stringValues,
  businessGroup: stringValues,
  buySell: stringValues,
  client: client => ({
    value: client.OrbClientId,
    label: client.ClientName,
    longDisplay: client.DisplayName
  }),
  currency: stringValues,
  currencyPair: stringValues,
  deliveryType: stringValues,
  finalPriceType: stringValues,
  orderType: stringValues,
  optionType: stringValues,
  optionExerciseStyle: stringValues,
  instrumentType: instrumentType => ({
    value: instrumentType.InstrumentTypeId,
    label: instrumentType.DisplayName
  }),
  notionalSchedule: stringValues,
  priceType: stringValues,
  placeofSettlement: stringValues,
  referenceRate: stringValues,
  returnorPayoutTrigger: stringValues,
  salesPerson: salesPerson => ({
    value: salesPerson.Id,
    label: salesPerson.Name
  }),
  subProduct: stringValues,
  trader: trader => ({
    value: trader.Id,
    label: trader.Name
  }),
  tradingSystem: system => ({
    value: system.TradingSystemId,
    label: system.Name
  }),
  transactionType: stringValues,
  timeZone: timeZone => ({
    value: timeZone.ZoneName,
    label: timeZone.DisplayName,
    offset: timeZone.UTCOffset,
    longDisplay: timeZone.DisplayName
  }),
  unitType: stringValues,
  underlyingAssetType: stringValues,
  underlyingInstrumentIndex: stringValues,
  valuationMethodorTrigger: stringValues,
  termofContractUnit: stringValues
};

export const flattenTimeZones = (timeZones) => {
  if (timeZones && timeZones.length > 0) {
    const flattenedZones = _.flatMap(timeZones, flattenSingleZone);
    return flattenedZones;
  }
  return [];
};

const flattenSingleZone = (zone) => {
  const { UTCOffset, ZoneNames } = zone;
  const mappedValues = ZoneNames.map(zoneName => ({
    DisplayName: zoneName.DisplayName,
    ZoneName: zoneName.ZoneName,
    SupportsDaylightSaving: zoneName.SupportsDaylightSaving,
    UTCOffset
  }));

  return mappedValues;
};



// WEBPACK FOOTER //
// ./src/utility/mapStaticData.js